
const submissionGridConstant = {
    event: {
        SUBMISSIONS_LOADED: 'umSubmissionGrid.submissionsLoaded',
        OPEN_SUBMISSION_DETAIL_DRAWER: 'umSubmissionGrid.openSubmissionDetailDrawer',
        CLOSE_SUBMISSION_DETAIL_DRAWER: 'umSubmissionGrid.closeSubmissionDetailDrawer',
        RESET_GRID_COLUMNS: 'umSubmissionGrid.resetGridColumns',
        RESET_GRID_LIST: 'umSubmissionGrid.resetGridList',
        MODIFIED_COLUMN_SELECTION: 'umSubmissionGrid.modifiedColumnSelection'
    }
};

angular.module('gw-um-submission-grid')
    .constant('submissionGridConstant', submissionGridConstant);
